export const ID_TOP_BAR_COIN_ICON = {
  MOBILE: "mobile-points-icon",
  DESKTOP: "desktop-points-icon",
};

export const BOTTOM_NAVIGATION_HEIGHT = 60;
export const TOP_NAVIGATION_HEIGHT = 60;
